import { przezmorzeApi } from "../../../api/api";
import { useQuery } from "@tanstack/react-query";

export interface ECommerceOffer {
  name: string;
  orderId: string;
  packageId: string;
  participantsNumber: number;
  dates: {
    from: string;
    to: string;
  };
}

export function useECommerceOffersForPackage(pkgId: string) {
  const { data, isLoading } = useQuery({
    queryKey: ["public", "packages", pkgId, "offers"],
    queryFn: async ({ signal }) =>
      (await przezmorzeApi.get<ECommerceOffer[]>(`/public/packages/${pkgId}/offers`, { signal })).data,
  });
  return {
    offers: data ?? [],
    isLoading,
  };
}
